import { Navigate, useLocation } from "react-router-dom";
import { PrivateRouteProps } from "./type";
import { useSupabaseAuth } from "../Context/AuthContext/AuthContext";
import { Capacitor } from "@capacitor/core";

const isAuthenticated = (user: any, profile: any, currentPath: string): boolean => {
  console.log("public route check if user is not authenticated", user, profile, currentPath);

  // For "/verify-phone-number" route, check both user and profile.user_name
  if (currentPath === "/verify-phone-number" && Capacitor.isNativePlatform()) {
    if (user && profile?.user_name) {
      return false;
    }
  } else {
    // For all other routes, only check if user exists
    if (user) {
      return false;
    }
  }
  
  return true;
};

export const PublicRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { useAuthStore } = useSupabaseAuth();
  const user = useAuthStore((state: any) => state.user);
  const profile = useAuthStore((state: any) => state.profile);
  const location = useLocation();
  const currentPath = location.pathname;
  const fromState = location.state?.from;
  if (isAuthenticated(user, profile, currentPath)) {
    return <>{children}</>;
  } 
  else {
    if (fromState === "login" && user && currentPath === "/verify-phone-number" && !Capacitor.isNativePlatform()) {
      return (
        <Navigate
          to="/user-details"
          replace
        />
      );
    }

    return (
      <>
        <Navigate
          to="/chatbot-ai"
          replace
          state={{
            showAnimation: true,
            showPaywall: true,
            checkOnboarding: true,
          }}
        />
      </>
    );
  }
};
